import { Box, Popover, List, ListItem, ListItemText, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProffesionalDetails, setSelectedGenderType, setselectedDate, setselectedProffesionalDetails, setselectedTime, setselectedTreatmentTypes } from "../../store/slice/Salon.slice";

const GenderComponent = ({ isOpen, handleClose, Ref,loader }) => {
  const dispatch=useDispatch()
  const theme =useTheme()
  const{genderType,selectedGenderType,languageWords}=useSelector((store)=> store?.salon)
  const{css}=useSelector((store)=> store?.widgetSettings)
  const gender = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Gender"
  )?.fields

  const handleSelectGenderType = (genderdata) => {
    dispatch(setselectedTreatmentTypes({}))
    dispatch(setselectedProffesionalDetails({}))
    dispatch(setselectedDate(''))
    dispatch(setselectedTime(''))
    dispatch(setSelectedGenderType(genderdata))
    handleClose();
  };
  const [anchorOriginVert, setAnchorOriginVert] = useState('bottom'); // default
  const [transformOriginVert, setTransformOriginVert] = useState('top'); // default


  useEffect(() => {
    if (Ref?.current) {
      const rect = Ref?.current?.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // If input is near the bottom 150px of the viewport, show popover above
      if (rect.bottom + 400 > viewportHeight) { // 400 ~ popover height
        setAnchorOriginVert('top');
        setTransformOriginVert('bottom');
      } else {
        setAnchorOriginVert('bottom');
        setTransformOriginVert('top');
      }
    }
  }, [isOpen, Ref]);

 if(loader) return 
 <Box>
  <Typography>loading ...</Typography>
 </Box>

  return (
    <Popover
    open={isOpen}
    anchorEl={Ref?.current}
    onClose={handleClose}
    anchorOrigin={{
      vertical: anchorOriginVert,
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: transformOriginVert,
      horizontal: 'center',
    }}
    PaperProps={{
      sx: {
        borderRadius: 2,
        boxShadow: 3,
        overflow: 'hidden',
        mt: 1,
        minWidth: 200,
        width:200,
        
      },
    }}
    disableEnforceFocus
     disableAutoFocus 
     disableRestoreFocus
  >
            <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 1.5,
            backgroundColor:gender?.genderBgMainClr
          }}
        >
          <Typography
            sx={{
              color:gender?.genderHeadingClr,
              fontSize: "14px",
              fontWeight: "bold",
              px:2,
            }}
          >
            {languageWords?.Gender ?? 'Gender'}
          </Typography>
        </Box>
    <List disablePadding>
      {genderType?.filter((item) => item?.active)?.map((table) => {
        const isSelected = selectedGenderType?.idGender === table?.idGender;
        return (
          <ListItem
            key={table.idGender}
            disablePadding
            onClick={() => handleSelectGenderType(table)}
            selected={isSelected}
            sx={{
              px: 2,
              py: 1.5,
              backgroundColor: isSelected ? gender?.genderItemSelectBgClr : gender?.genderItemBgClr,
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor:gender?.genderBghover,
                color:gender?.genderTxtHover,
              },
              color: isSelected ? gender?.genderItemSelectTxtClr : gender?.genderItemTxtClr,
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontWeight: isSelected ? 'bold' : 'normal',
                textAlign: 'center',
                fontSize: '0.95rem',
               
              }}
              primary={table.gender}
            />
          </ListItem>
        );
      })}
    </List>
  </Popover>


  
  );
};

export default GenderComponent;
